import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxColor } from '@onyx/angular';
import { OnyxInformationHeadingComponent } from '@onyx/angular';
import { SwapUnassignPointReason } from '../../../../../enums/swap/swap-unassign-point-reason';
import { SwapVehicleType } from '../../../../../enums/swap/swap-vehicle-type';
import type { Swap } from '../../../../../interfaces/swap/swap';
import { SwapModalSummaryItemUnassignedPointsGroupComponent } from './swap-modal-summary-item-unassigned-points-group/swap-modal-summary-item-unassigned-points-group.component';

@Component({
  selector: 'app-swap-modal-summary-item-unassigned-points',
  imports: [
    OnyxInformationHeadingComponent,
    TranslatePipe,
    SwapModalSummaryItemUnassignedPointsGroupComponent,
  ],
  templateUrl: './swap-modal-summary-item-unassigned-points.component.html',
  styleUrl: './swap-modal-summary-item-unassigned-points.component.scss',
})
export class SwapModalSummaryItemUnassignedPointsComponent {
  public readonly type = input.required<SwapVehicleType>();
  public readonly swap = input.required<Swap>();
  public readonly identifierColor = input.required<OnyxColor | null>();
  public readonly isDouble = input.required<boolean>();

  protected readonly I18N = 'map.swapPanel';

  protected readonly SwapUnassignPointReason = SwapUnassignPointReason;

  protected points = computed(() => {
    const isPrimary = this.type() === SwapVehicleType.PRIMARY;

    return {
      unassignedPoints: isPrimary
        ? this.swap().vehicleUnassignedPoints
        : this.swap().otherVehicleUnassignedPoints,
      unassignedTrailerPoints: isPrimary
        ? this.swap().vehicleSemiTrailerPoints
        : this.swap().otherVehicleSemiTrailerPoints,
    };
  });
  protected hasUnassignedPoints = computed(
    () =>
      !!this.points().unassignedPoints?.length ||
      !!this.points().unassignedTrailerPoints?.length,
  );
}
